export function getMetaDataServiceUrl(): string {
  return sgSettings.config.crossword.metaDataServiceBaseUrl;
}
